import React from 'react'
import { Offer } from 'src/core/models'
import styles from './OffersColumnMovileView.module.scss'
import { getFormatedPrice, getNaturalDate } from 'src/core/helpers'
import { FormLabels, OfferStatusColumn, OffersActionColumn, CustomText } from 'src/components'

const OffersColumnMovileView: React.FC<{ offer: Offer }> = ({ offer }) => {
  const offerPrice = `${offer.amount} tCO₂ @ ${getFormatedPrice(offer.price, offer.currency)}`
  const total = getFormatedPrice(offer.amount * offer.price, offer.currency)

  return <>
    <FormLabels
      title={offer.project_name}
      subtitle={offerPrice}
      thirdLabel={`${total}`}
    />
    <CustomText label={getNaturalDate(offer.date)} />

    <div className={styles.content}>
      <OfferStatusColumn offer={offer} />
      <OffersActionColumn offer={offer} />
    </div>
  </>
}

export default OffersColumnMovileView
